import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { StatusType } from "../interfaces/status-type.interface";
import { HistoryItem } from "../interfaces/history-item.interface";

@Injectable({
  providedIn: 'root',
})
export class HistoryApiService {
  http = inject(HttpClient);

  getHistory$(type: StatusType, accountId: number) {
    return this.http.get<HistoryItem[]>(`/senderidregistry/manage/history/list/${type}/${accountId}`);
  }
}
